export default "__VITE_ASSET__BDUKArRO__"